export default __webpack_public_path__ + "static/media/help-group.9e099307.svg";